export default {
  feeTab: {
    fee: '费用',
    receivable: '应收',
    payable: '应付',
    summary: '汇总',
    detail: '明细',
    receivableTotal: '应收',
    receivablePending: '待收',
    payableTotal: '应付',
    payablePending: '待付',
    feeItems: '费用项',
    feeName: '费用项',
    settlementParty: '结算对象',
    billingUnit: '计费单位',
    settlementUnitPrice: '结算单价',
    quantity: '数量',
    settlementCurrency: '结算币种',
    settlementAmount: '结算金额',
    baseCurrency: '本位币',
    exchangeRate: '汇率',
    baseCurrencyAmount: '本位币金额',
    source: '来源',
    sourceSYSTEM: '系统计算',
    sourceMANUAL: '手动新增',
    systemCalculatedAmount: '系统计算金额',
    apiAmount: 'API金额',
    invoiceAmount: '发票金额',
    status: '状态',
    writeOffStatus: '核销状态',
    status0: '待确认',
    status1: '已确认',
    verificationStatus0: '未核销',
    verificationStatus1: '已核销',
    trackingNumber: '跟踪单号',
    packageNo: '包裹号',
    invoiceNo: '发票单号',
    invoiceWeek: '发票周数',
    expenseTime: '费用发生时间',
    createdBy: '创建人',
    remark: '备注',
    batchConfirm: '批量确认',
    cancelConfirm: '取消确认',
    recalculateFee: '费用重算',
    receivableSummaryFileName: '应收汇总费用.csv',
    receivableDetailFileName: '应收明细费用.csv',
    payableSummaryFileName: '应付汇总费用.csv',
    payableDetailFileName: '应付明细费用.csv',
    addFee: '新增费用',
    editFee: '编辑费用',
    numberRange: '请输入大于0且不超过{max}的数值',
    billingUnits: {
      kilogram: '公斤',
      ton: '吨',
      cubicMeter: '立方米',
      shipment: '票',
      piece: '件',
      carton: '箱',
      pallet: '托',
      container: '柜',
      occurrence: '次',
      hour: '小时',
      centimeter: '厘米',
      rate: '费率',
    },
  },
};
